// @ts-nocheck
// ClubBookActionsSheet — menu "..." ENXUTO do card de livro de CLUBE no Home.
// Só duas ações, que são o que de fato pertence ao membro:
//   • Corrigir posição inicial (sincroniza onde o membro está, sem somar como
//     leitura de hoje) — opera sobre o espelho pessoal do livro de clube.
//   • Sair do clube (ação limpa via endpoint próprio, com confirmação).
// NÃO edita info do livro (é definido pelo grupo) nem "remove" (semântica
// diferente — removeria o vínculo/órfão). Por isso é um componente separado do
// BookActionsSheet pessoal.
import React, { useState } from 'react';
import { Icon } from './icons';
import { unitMeta } from './units';

const inputStyle = { width: '100%', padding: '13px 14px', borderRadius: 12, background: 'var(--paper-2)', border: '1px solid var(--line)', color: 'var(--ink)', fontSize: 15, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' };
const lbl = { fontSize: 9.5, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--ink-3)', display: 'block', fontWeight: 600 };
const primaryBtn = (disabled) => ({ width: '100%', marginTop: 16, padding: 15, borderRadius: 14, background: 'var(--ember)', color: '#fff', fontSize: 15, fontWeight: 600, border: 'none', opacity: disabled ? 0.5 : 1, cursor: disabled ? 'default' : 'pointer' });

export const ClubBookActionsSheet = ({ club, mirror, term = 'clube', onClose, onSyncInitial, onLeave, onDelete }) => {
  const isOwner = club?.yourRole === 'owner';
  const cbook = club?.book || club?.myBook || {};
  const total = (mirror?.pages ?? cbook.totalPages) || 0;
  const u = unitMeta(mirror?.progressUnit || cbook?.progressUnit);
  const [mode, setMode] = useState('menu');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const [page, setPage] = useState(String(mirror?.read ?? cbook.yourPage ?? 0));

  const wrap = async (fn) => { setBusy(true); setErr(null); try { await fn(); onClose(); } catch (e) { setErr(e?.message || 'Erro ao salvar'); } finally { setBusy(false); } };

  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', inset: 0, zIndex: 95, background: 'rgba(20,16,14,0.55)', backdropFilter: 'blur(4px)' }} />
      <div style={{ position: 'fixed', left: 0, right: 0, bottom: 0, zIndex: 96, background: 'var(--paper)', borderTopLeftRadius: 24, borderTopRightRadius: 24, padding: '14px 20px calc(28px + env(safe-area-inset-bottom, 0px))', maxWidth: 460, margin: '0 auto', boxShadow: '0 -16px 40px rgba(0,0,0,0.2)' }}>
        <div style={{ width: 40, height: 4, borderRadius: 2, background: 'var(--line)', margin: '0 auto 14px' }} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
          <div style={{ width: 36, height: 50, borderRadius: 7, flexShrink: 0, overflow: 'hidden', background: `linear-gradient(135deg, oklch(0.78 0.09 ${cbook.coverHue ?? 22}), oklch(0.45 0.10 ${cbook.coverHue ?? 22}))` }}>{cbook.coverUrl && <img src={cbook.coverUrl} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="serif" style={{ fontSize: 17, lineHeight: 1.1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{cbook.title || 'Livro do clube'}</div>
            <div style={{ fontSize: 12, color: 'var(--ink-3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{term} · {club?.name}</div>
          </div>
          {mode !== 'menu' && <button onClick={() => { setMode('menu'); setErr(null); }} style={{ fontSize: 13, color: 'var(--ink-3)', padding: 6, background: 'transparent', cursor: 'pointer', flexShrink: 0 }}>← Voltar</button>}
        </div>

        {err && <div style={{ padding: '10px 14px', borderRadius: 10, marginBottom: 12, background: 'rgba(232,122,59,0.12)', color: 'var(--ember)', fontSize: 13 }}>{err}</div>}

        {mode === 'menu' && (
          <div>
            <button onClick={() => setMode('sync')} style={{ width: '100%', padding: '15px 4px', textAlign: 'left', display: 'flex', alignItems: 'center', gap: 12, color: 'var(--ink-2)', fontSize: 15, borderBottom: '1px solid var(--line)', background: 'transparent', cursor: 'pointer' }}>
              <Icon name="pen" size={18} color="var(--ink-3)" />Corrigir {u.where} inicial
            </button>
            {/* "Compartilhar" saiu daqui: virou ícone visível ao lado do "..."
                no próprio card, e agora gera o adesivo de Stories. */}
            {isOwner ? (
              // Owner não pode "sair" (é dono) — a saída equivalente é excluir o clube.
              <button onClick={() => { onClose(); onDelete && onDelete(); }} style={{ width: '100%', padding: '15px 4px', textAlign: 'left', display: 'flex', alignItems: 'center', gap: 12, color: 'var(--ember)', fontSize: 15, background: 'transparent', cursor: 'pointer' }}>
                <Icon name="trash" size={18} color="var(--ember)" />Excluir {term}
              </button>
            ) : (
              <button onClick={() => { onClose(); onLeave(); }} style={{ width: '100%', padding: '15px 4px', textAlign: 'left', display: 'flex', alignItems: 'center', gap: 12, color: 'var(--ember)', fontSize: 15, background: 'transparent', cursor: 'pointer' }}>
                <Icon name="log-out" size={18} color="var(--ember)" />Sair do {term}
              </button>
            )}
          </div>
        )}

        {mode === 'sync' && (
          <div>
            <div style={{ fontSize: 13, color: 'var(--ink-3)', marginBottom: 10, lineHeight: 1.45 }}>Onde você está agora neste livro? Ajusta sua posição <strong style={{ color: 'var(--ink-2)' }}>sem somar como leitura de hoje</strong>.</div>
            <label style={lbl}>Onde você está{total ? ` · de ${total} ${u.short}` : ''}</label>
            <input type="number" inputMode="numeric" min={0} max={total || 999999} value={page} onChange={e => setPage(e.target.value)} style={{ ...inputStyle, marginTop: 6 }} />
            <button disabled={busy} onClick={() => wrap(() => onSyncInitial(Math.max(0, parseInt(page, 10) || 0)))} style={primaryBtn(busy)}>{busy ? 'Salvando…' : 'Salvar minha página'}</button>
          </div>
        )}
      </div>
    </>
  );
};
